import { type ISbStoryData } from '@storyblok/react'

import { cmsGetStoryblokLinkHref } from '../../cmsGetStoryblokLinkHref'
import { cmsStoryblokSlugToPublicUrl } from '../../cmsStoryblokSlugToPublicUrl'
import { type StoryblokPageContentType } from '../storyblokPageContentTypes'

/**
 * returns seoCanonical:
 * - if linked story -> absolute path with domain/host
 * - if string -> return as is
 * - if empty -> return full absolute url for story
 */
export const storyAccessorGetCanonicalUrl = (
  story: ISbStoryData<StoryblokPageContentType>,
): string => {
  if (story.content.seoCanonical) {
    const seoCanonical = cmsGetStoryblokLinkHref(story.content.seoCanonical)

    if (seoCanonical) {
      return seoCanonical
    }
  }

  return cmsStoryblokSlugToPublicUrl(story.full_slug, {
    addTenantHostFromPathPrefix: true,
  })
}
